import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  pageInfo: {
    page: 1,
    limit: 10,
    totalPage: 2
  },
  condition:{
    page:1,
    limit:10
  },

  list: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
